module.exports = __webpack_public_path__ + "img/logo.de542875.png";